import { useIsSelectedMetric360 } from '../useIsSelectedMetric360/useIsSelectedMetric360';
import { useSelectedCyclesMatching360Check } from '../useSelectedCyclesMatching360Check/useSelectedCyclesMatching360Check';

export const useShow360UnavailableInfoBar = () => {
  const isSelectedMetric360 = useIsSelectedMetric360();
  const getNon360SelectedCycles = useSelectedCyclesMatching360Check(true);

  return isSelectedMetric360 && getNon360SelectedCycles().length === 0;
};
